import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import throttle from 'lodash/throttle';
import API from '../create/api';
import * as helper from '../../helper/index';

export default function Area({ onChange, defaultValue = null, disabled = false }: any) {
  const [loading, setLoading] = React.useState(false);
  const [options, setOptions]: any = React.useState([]);
  const [inputValue, setInputValue] = React.useState('');
  const [value, setValue] = React.useState(defaultValue);

  // Add effect to sync with defaultValue changes
  React.useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const fetch_companies = React.useMemo(() => {
    setLoading(true);
    return throttle(async (inputValue) => {
      await API.getAll(`${process.env.REACT_APP_API_SERVER}/areas?name_contains=${inputValue}&_limit=10`)
        .then((res: any) => {
          const companies = res.map((c: any) => {
            return {
              label: `${c.id} - ${c.name}`,
              value: c.id,
              key: `${c.id}-${c.name}`, // Ensure uniqueness
              raw: c,
            };
          });
          setOptions(companies);
        })
        .catch((e) => {
          helper.axiosErrorHandling(e);
        })
        .finally(() => {
          setLoading(false);
        });
    }, 200);
  }, []);

  React.useEffect(() => {
    fetch_companies(inputValue);
  }, [inputValue, fetch_companies]);

  return (
    <Autocomplete
      disabled={disabled ?? loading}
      value={value}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      getOptionLabel={(option: any) => option?.label ?? ''}
      options={options}
      loading={loading}
      onChange={(e, newValue) => {
        setValue(newValue);
        onChange(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          fullWidth
          label="Area"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}
